import { Playground } from 'docz';
import { useScript } from "../../../../../src/index";
import * as React from 'react';
export default {
  Playground,
  useScript,
  React
};